import { Box, Button, styledComponent, Typography, Chevron } from '@hermes/web-components'

export const RecommendedSellerTitle = styledComponent(Typography)(({ theme }) => ({
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 500,
  color: theme.palette.neutral[900]
}))

type BoxProps = typeof Box.arguments
interface StyledBoxProps extends BoxProps {
  isRecommended: boolean
}
export const RecommendedSellerTitleContainer = styledComponent(Box, {
  shouldForwardProp: (prop) => prop !== 'isRecommended'
})<StyledBoxProps>(({ theme, isRecommended }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: theme.palette.neutral[200],
  padding: '6px 12px',
  borderRadius: '12px 0',
  margin: '0px',

  ...(isRecommended && {
    backgroundColor: theme.palette.tertiary[300]
  })
}))

export const SellerFullName = styledComponent(Typography)(() => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}))

export const SellerPrice = styledComponent(Typography)(() => ({
  WebkitLineClamp: '1',
  wordBreak: 'break-word',
  WebkitBoxOrient: 'vertical',
  display: '-webkit-box',
  overflow: 'hidden'
}))

export const BookImageContainer = styledComponent(Box, {
  shouldForwardProp: (prop) => prop !== 'disabled'
})<{ disabled?: boolean }>(({ disabled = false }) => ({
  ...(disabled ? { cursor: 'auto' } : { cursor: 'pointer' }),
  overflow: 'hidden',
  borderRadius: '4px',
  width: '60px',
  height: '100%',
  position: 'relative',

  img: {
    position: 'absolute',
    borderRadius: '4px',
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  }
}))

export const SeeAllButton = styledComponent(Button)(({ theme }) => ({
  display: 'inline-flex',
  fill: theme.palette.primary.main,
  color: theme.palette.primary.main,
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: 500,
  padding: '5px 0 5px 0',

  ':disabled': { border: 'none', svg: { fill: theme.palette.neutral.main } }
}))

export const RightChevron = styledComponent(Chevron)(() => ({
  rotate: '-90deg',
  width: '20px'
}))
